module.exports = __webpack_public_path__ + "img/cash1.c2178532.svg";